import { useNavigate, useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";

// Returns a navigator that scrolls to a section on the home page when already
// there, or routes home (with hash) first when on another page.
export const useSectionNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (href) => {
    const isHome = location.pathname === "/";

    if (href === "/" || href === "#top") {
      if (isHome) scrollToId("#top");
      else navigate("/");
      return;
    }

    if (isHome) {
      scrollToId(href);
    } else {
      navigate("/" + href); // e.g. "/#contact"
    }
  };
};
